import './TimelineStatsTab.css';
import { useEffect, useState } from "react"
import SubTabParent from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabParent"
import SubTabSection from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabSection"
import SectionLoader from "../../../../_shoru_shared_library/loaders/SectionLoader";
import PerformanceGraph from "./components/PerformanceGraph";
import { Info } from '@mui/icons-material';

// TO DELETE
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../../../../_shoru_shared_library/firebase/firebase_setup';


export default function TimelineStatsTab(props) {

  const [graphs, setGraphs] = useState(null);
  const [graphAverages, setGraphAverages] = useState(null);

  const [totalAuditions, setTotalAuditions] = useState(null);
  const [totalRoles, setTotalRoles] = useState(null);

  const [displayedSeasons, setDisplayedSeasons] = useState(10);

  const projectData = props.projectData;
  const castingData = props.extraData;
  const seasons = props.organisationData.seasons;

  const totalProjects = props.projectData.length;
  const totalCastingMeetings = seasons.length;


  useEffect(() => {
    if(!seasons || !castingData || !projectData) return;
    const graphs = {};
    const slicedSeasons = seasons.slice(-displayedSeasons);

    const graphYsBase = {
      health: 0, projects: 0, roles: 0, auditions: 0, auditionees: 0, auditionees_per_role: 0, bookings_per_auditionee: 0
    }

    slicedSeasons.forEach((season, index) => {
      graphs[season.uid] = {
        name: season.name,
        x: index,
        ys: {...graphYsBase},
        data: { auditioneeIds: [], healthyProjects: 0 },
      };
    });

    let totalAuditions = 0;
    let totalRoles = 0

    castingData.forEach((project) => {
      const seasonId = getSeasonId(project.uid, projectData);
      const graph = graphs[seasonId];

      if (!graph) {
        console.error(`Could not find season "${seasonId}" for project "${project.uid}"`);
        return;
      }

      graph.ys.projects += 1;
      graph.ys.roles += project.roles?.length ?? 0;
      totalRoles += project.roles?.length ?? 0;
      let projectAuditionees = [];

      project.slots?.forEach((slot) => {
        if (!slot.auditionee_id) return;

        graph.ys.auditions += 1;
        totalAuditions += 1;

        if(!projectAuditionees.includes(slot.auditionee_id)) {
          projectAuditionees.push(slot.auditionee_id);
        }

        if (!graph.data.auditioneeIds.includes(slot.auditionee_id)) {
          graph.data.auditioneeIds.push(slot.auditionee_id);
          graph.ys.auditionees += 1;
        }
      });

      const isHealthy = (threshold) => {
        return project.roles?.length ? (projectAuditionees.length / project.roles.length) >= threshold : 0;
      }

      if(isHealthy(5)) graph.data.healthyProjects += 1;
      else if(isHealthy(3)) graph.data.healthyProjects += 0.5;
    });

    Object.keys(graphs).forEach((key) => {
      const graph = graphs[key];
      graph.ys.health = (graph.data.healthyProjects / graph.ys.projects) * 100;
      graph.ys.auditionees_per_role = (graph.ys.roles) ? (graph.ys.auditionees / graph.ys.roles) : 0;
      graph.ys.bookings_per_auditionee = (graph.ys.auditionees) ? (graph.ys.auditions / graph.ys.auditionees) : 0;
    });

    // Calculate averages
    let totals = {...graphYsBase}
    let ignoredSeasons = {...graphYsBase}
    Object.keys(graphs).forEach(graphKey => {
      const graph = graphs[graphKey];
      Object.keys(totals).forEach(key => {
        if(graph.ys[key] === 0) ignoredSeasons[key] += 1;
        totals[key] += graph.ys[key];
      });
    });
    let averages = {...graphYsBase}
    Object.keys(averages).forEach(key => {
      averages[key] = totals[key] / (slicedSeasons.length - ignoredSeasons[key]);
    });

    setGraphs(graphs);
    setTotalAuditions(totalAuditions);
    setTotalRoles(totalRoles);
    setGraphAverages(averages);
  }, [seasons, castingData, projectData]);



  return (
    <SubTabParent passData={props}>
      <SubTabSection title='Performance Graph'>
        <PerformanceGraph graphs={graphs} averages={graphAverages} seasons={seasons.slice(-displayedSeasons)} />
      </SubTabSection>
      <SubTabSection title='All-Time Performance' no_background>
        <div className='tst-all-time-container'>
          <StatLine label='Projects Made' value={totalProjects} />
          <StatLine label='Seasons Cast' value={totalCastingMeetings} />
          <StatLine label='Auditions Booked' info='Since Summer 2025' value={totalAuditions} />
          <StatLine label='Roles Created' info='Since Summer 2025' value={totalRoles} />
          <StatLine label='First Used' value={seasons[0].name} />
        </div>
      </SubTabSection>

    </SubTabParent>
  ) 
}



function getSeasonId(uid, projectData) {
  let result = null;
  projectData.forEach((p) => {
    if(p.uid === uid) {
      result = p.season;
    }
  });
  return result;
}


function StatLine({label, value, info}) {
  return (
    <div className='tst-statline'>
      <p>{label}: <b style={{marginLeft: '10px'}}>{value}</b></p>
      {
        info && 
        <div className='tst-statline-info'>
          <Info />
          <p>{info}</p>
        </div>
      }
    </div>
  )
}